// extracted by mini-css-extract-plugin
module.exports = {"root":"ThirdPartyLogo_root__7CgHf","square":"ThirdPartyLogo_square__naykb","portrait":"ThirdPartyLogo_portrait__981mx","landscape":"ThirdPartyLogo_landscape__tk1R9"};